import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rotation-box"
}
const _hoisted_2 = { class: "pane1" }
const _hoisted_3 = { class: "icon-list" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "action with-tooltip" }
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = { class: "tooltip" }
const _hoisted_8 = { class: "action with-tooltip" }
const _hoisted_9 = ["src", "alt", "onClick"]
const _hoisted_10 = { class: "tooltip" }
const _hoisted_11 = { class: "action with-tooltip" }
const _hoisted_12 = ["src", "alt", "onClick"]
const _hoisted_13 = { class: "tooltip" }
const _hoisted_14 = { class: "control-button" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  key: 1,
  class: "action-attribute"
}
const _hoisted_18 = { class: "rotation-list" }
const _hoisted_19 = { class: "rotation-item" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "with-tooltip handle" }
const _hoisted_22 = ["src", "alt", "onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "action-attribute" }
const _hoisted_25 = {
  key: 0,
  class: "pane2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ERCalculator = _resolveComponent("ERCalculator")!

  return (_ctx.watchCount)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("fieldset", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team.members, (member) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: member.id
              }, [
                (member.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          class: _normalizeClass('action-icon' + _ctx.bgColorClass(member.name)),
                          src: _ctx.normalAttackIconSrc(member.name),
                          alt: _ctx.displayName(member.name) + ' ' + _ctx.displayName('通常攻撃'),
                          onClick: ($event: any) => (_ctx.listActionOnClick(member, 'N'))
                        }, null, 10, _hoisted_6),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.displayName(member.name) + ' ' + _ctx.displayName('通常攻撃')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          class: _normalizeClass('action-icon' + _ctx.bgColorClass(member.name)),
                          src: _ctx.elementalSkillIconSrc(member.name),
                          alt: _ctx.displayName(member.name) + ' ' + _ctx.displayName('元素スキル'),
                          onClick: ($event: any) => (_ctx.listActionOnClick(member, 'E'))
                        }, null, 10, _hoisted_9),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.displayName(member.name) + ' ' + _ctx.displayName("元素スキル")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                          class: _normalizeClass('action-icon' + _ctx.bgColorClass(member.name)),
                          src: _ctx.elementalBurstIconSrc(member.name),
                          alt: _ctx.displayName(member.name) + ' ' + _ctx.displayName('元素爆発'),
                          onClick: ($event: any) => (_ctx.listActionOnClick(member, 'Q'))
                        }, null, 10, _hoisted_12),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.displayName(member.name) + ' ' + _ctx.displayName('元素爆発')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: "material-symbols-outlined control-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click:jump-to-team')))
                    }, "stat_2")
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("label", {
                      class: _normalizeClass(_ctx.removeMode ? 'checked' : '')
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.removeMode) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.removeMode]
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "material-symbols-outlined" }, "delete", -1))
                    ], 2)
                  ]),
                  _createElementVNode("td", null, [
                    (_ctx.selectedAction)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("img", {
                            class: _normalizeClass('action-icon handle' + _ctx.bgColorClass(_ctx.selectedAction.member)),
                            src: _ctx.getActionDetail(_ctx.selectedAction).icon_url,
                            alt: _ctx.displayName(_ctx.getActionDetail(_ctx.selectedAction).名前),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedActionOnClick(_ctx.selectedAction)))
                          }, null, 10, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedAction)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.actionDisplay(_ctx.selectedAction)), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_18, [
            _createVNode(_component_draggable, {
              list: _ctx.rotationList,
              "item-key": "id",
              sort: true,
              handle: ".handle",
              delay: 100,
              animation: 200,
              onChange: _ctx.rotationListOnChange
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.previousRotation(element)?.member != element.member)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "character-icon",
                        src: _ctx.getCharacterMaster(element.member)?.icon_url ?? _ctx.IMG_SRC_DUMMY,
                        alt: _ctx.displayName(element.member)
                      }, null, 8, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_ctx.getActionDetail(element))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass('action-item ' + _ctx.colorClass(element.member))
                      }, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("img", {
                            class: _normalizeClass('action-icon' + _ctx.bgColorClass(element.member) + _ctx.selectedActionClass(element)),
                            src: _ctx.getActionDetail(element).icon_url,
                            alt: _ctx.displayName(_ctx.getActionDetail(element).名前),
                            onClick: ($event: any) => (_ctx.rotationActionOnClick(element))
                          }, null, 10, _hoisted_22),
                          (_ctx.removeMode)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "remove-mark",
                                onClick: ($event: any) => (_ctx.removeItemOnClick(element))
                              }, null, 8, _hoisted_23))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.actionDisplay(element)), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["list", "onChange"]),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _withDirectives(_createElementVNode("textarea", {
              class: "rotation-description",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rotationDescription) = $event)),
              rows: "10",
              maxlength: "400",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateRotation && _ctx.updateRotation(...args)))
            }, null, 544), [
              [_vModelText, _ctx.rotationDescription]
            ])
          ]),
          _cache[7] || (_cache[7] = _createStaticVNode("<br data-v-b2eaab7c> <br data-v-b2eaab7c><br data-v-b2eaab7c> <br data-v-b2eaab7c><table class=\"guide\" data-v-b2eaab7c><tbody data-v-b2eaab7c><tr data-v-b2eaab7c><th data-v-b2eaab7c>N</th><td data-v-b2eaab7c>通常攻撃1段</td><th data-v-b2eaab7c>N2</th><td data-v-b2eaab7c>通常攻撃2段</td><th data-v-b2eaab7c>NX</th><td data-v-b2eaab7c>通常攻撃X段</td></tr><tr data-v-b2eaab7c><th data-v-b2eaab7c>N1C</th><td data-v-b2eaab7c>通常攻撃1段+重撃</td><th data-v-b2eaab7c>N2C</th><td data-v-b2eaab7c>通常攻撃2段+重撃</td><th data-v-b2eaab7c>NXC</th><td data-v-b2eaab7c>通常攻撃X段+重撃</td></tr><tr data-v-b2eaab7c><th data-v-b2eaab7c>C</th><td data-v-b2eaab7c>重撃</td><td colspan=\"4\" data-v-b2eaab7c></td></tr><tr data-v-b2eaab7c><th data-v-b2eaab7c>P</th><td data-v-b2eaab7c>落下攻撃</td><td colspan=\"4\" data-v-b2eaab7c></td></tr><tr data-v-b2eaab7c><th data-v-b2eaab7c>E</th><td data-v-b2eaab7c>元素スキル</td><th data-v-b2eaab7c>E.Press</th><td data-v-b2eaab7c>元素スキル(一回押し)</td><th data-v-b2eaab7c>E.Hold</th><td data-v-b2eaab7c>元素スキル(長押し)</td></tr><tr data-v-b2eaab7c><th data-v-b2eaab7c>Q</th><td data-v-b2eaab7c>元素爆発</td><td colspan=\"4\" data-v-b2eaab7c></td></tr></tbody></table>", 7))
        ]),
        true
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_ERCalculator, {
                team: _ctx.team,
                rotationList: _ctx.rotationList,
                teamMemberResult: _ctx.teamMemberResult,
                constellations: _ctx.constellations
              }, null, 8, ["team", "rotationList", "teamMemberResult", "constellations"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}